import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter,
} from '@angular/core';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss'],
})
export class TableComponent implements OnInit {
  @Input('displayedColumns') displayedColumns;
  @Input('dataSource') dataSource;
  @Input('tableType') tableType;
  @Input('dataSourceLength') dataSourceLength;
  @Input('dataSourcePageSize') dataSourcePageSize;
  @Input('dataSourceIndex') dataSourceIndex;
  @Input('pageSizeOptions') pageSizeOptions;
  @Input('disabledFlag') disabledFlag;
  @Input('idsList') idsList;
  @Input('globalFlag') globalFlag;
  @Input('disableGlobalSelect') disableGlobalSelect;

  @Output() pageChange: EventEmitter<number> = new EventEmitter();
  @Output() selectedValues: EventEmitter<any> = new EventEmitter();
  @Output() approveInvoice: EventEmitter<any> = new EventEmitter();
  @Output() deleteCampaignByID: EventEmitter<any> = new EventEmitter();
  @Output() incentiveID: EventEmitter<any> = new EventEmitter();
  @Output() GlobalCheck: EventEmitter<any> = new EventEmitter();
  @Output() downloadMessage: EventEmitter<any> = new EventEmitter();
  @Output() raiseDisputeParam: EventEmitter<any> = new EventEmitter();
  @Output() cancelDisputeParam: EventEmitter<any> = new EventEmitter();
  @Output() incentiveDownloadId: EventEmitter<any> = new EventEmitter();
  @Output() uploadFileParam: EventEmitter<any> = new EventEmitter();
  @Output() deleteUploadedFile: EventEmitter<any> = new EventEmitter();
  @Output() downloadEmailFile: EventEmitter<any> = new EventEmitter();
  @Output() erpID: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit() { }

  onPaginateChange(data) {
    this.pageChange.emit(data);
  }

  getIncentiveID(value) {
    var arrayList = [];
    if (value.checked) {
      arrayList.push(parseInt(value.source.value));
    }
    let idList = document.getElementsByClassName('selected-ref');
    for (var i = 0; i < idList.length; i++) {
      if (idList[i].children[0].classList.contains('mat-checkbox-checked')) {
        arrayList.push(
          parseInt(idList[i].children[0].getAttribute('ng-reflect-value'))
        );
      }
    }
    //console.log("getIncentiveID:", arrayList);
    if (value.checked == false) {
      let index = arrayList.indexOf(parseInt(value.source.value));
      if (index > -1) {
        arrayList.splice(index, 1);
      }
    }
    this.selectedValues.emit(arrayList);
    //console.log("getIncentiveID1:", arrayList);
  }

  incentiveInvoiceID(data) {
    this.approveInvoice.emit(data);
  }

  deleteCampaign(data) {
    this.deleteCampaignByID.emit(data);
  }

  downloadIncentive(data) {
    this.incentiveID.emit(data);
  }

  getInvoiceID(event: any, element: any) {
    // console.log("Event:", event);
    // console.log("Element ID:", element?.id);
    // console.log("Element Action:", element?.action);
    const invoiceId = element?.id;
    const isChecked = event.source.checked; //Correct way to check if checkbox is selected
    // console.log(" isChecked:", isChecked);  
    if (isChecked) {
      //Avoid duplicates
      let exists = this.idsList.some(item => item[0] === invoiceId);
      // console.log(" exists:", exists); 
      // console.log(" invoiceId:", invoiceId); 
      if (!exists) {
          // console.log("going"); 
          // console.log("inside idsList:", this.idsList);
        this.idsList.push([invoiceId, element?.action.toString().toLowerCase() === 'true']);
      }
    } else {
      //Remove only the unchecked item
      // console.log("not going"); 
      this.idsList = this.idsList.filter(item => item[0] !== invoiceId);
    }
   
    // console.log("Updated idsList:", this.idsList);
    this.selectedValues.emit(this.idsList); // emit updated list
  }


  checkBoxStatus(id: number, checkbox_status: boolean): boolean {
    return this.idsList.some(item => item[0] === id) || checkbox_status;
  }

  // checkBoxStatus(data, status) {
  //   if (this.idsList.length == 0) {
  //     return false;
  //   }
  //   if(status == true){
  //     let index = this.idsList.findIndex(
  //       (item) => item[0] == parseInt(data)
  //     );
  //     if (index > -1) {
  //       this.idsList.splice(index, 1);
  //     }
  //   }
  //   //console.log("idslist-table.components.ts", this.idsList);
  //   return this.idsList.filter((id) => id[0] == data);  
  // }

  globalCheckFiling(data) {
    //console.log("globalCheckFiling:", data);
    this.GlobalCheck.emit(data.checked);
  }

  showDownloadMessage(data) {
    this.downloadMessage.emit(data);
  }

  raiseDispute(data) {
    this.raiseDisputeParam.emit(data);
  }

  resolveDispute(data) {
    this.raiseDisputeParam.emit(data);
  }

  cancelDispute(data) {
    this.cancelDisputeParam.emit(data);
  }

  incentiveId(data) {
    this.incentiveDownloadId.emit(data);
  }

  uploadDataFile(data) {
    this.uploadFileParam.emit(data);
  }

  deleteUploadDataFile(data) {
    this.deleteUploadedFile.emit(data);
  }

  pushToErp(data) {
    this.erpID.emit(data);
  }

  downloadEmailDataFile(data) {
    this.downloadEmailFile.emit(data);
  }
}
